(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/email-card.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/email/email-card.js');
'use strict';

const _svs$ui$ReactCard = svs.ui.ReactCard,
  CardBody = _svs$ui$ReactCard.CardBody,
  CardExpandableBody = _svs$ui$ReactCard.CardExpandableBody;
const _svs$myProfile$react$ = svs.myProfile.react.pages.myInformation.myInformation.components,
  WhiteCardHeader = _svs$myProfile$react$.WhiteCardHeader,
  PdCard = _svs$myProfile$react$.PdCard;
const _svs$myProfile$react$2 = svs.myProfile.react.pages.myInformation.myInformation.email,
  EmailConfirm = _svs$myProfile$react$2.EmailConfirm,
  EmailSave = _svs$myProfile$react$2.EmailSave,
  EmailText = _svs$myProfile$react$2.EmailText,
  EmailFooter = _svs$myProfile$react$2.EmailFooter;

const EmailCard = _ref => {
  let _ref$isFocused = _ref.isFocused,
    isFocused = _ref$isFocused === void 0 ? false : _ref$isFocused;
  const dispatch = ReactRedux.useDispatch();
  const _ReactRedux$useSelect = ReactRedux.useSelector(state => state.playerPreferences.playerPreferences),
    emailStatus = _ReactRedux$useSelect.emailStatus,
    email = _ReactRedux$useSelect.email;
  const _ReactRedux$useSelect2 = ReactRedux.useSelector(state => state.playerPreferences),
    isForceSaveEmail = _ReactRedux$useSelect2.isForceSaveEmail;
  const setForceSaveEmail = svs.myProfile.react.store.pdPreferences.actions.setForceSaveEmail;
  const emailVerified = "".concat(emailStatus) === '2';
  const emailExists = Boolean(email);
  const emailRef = React.useRef(null);
  React.useEffect(() => {
    if (isFocused && emailRef) {
      emailRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [isFocused]);
  const onChange = () => {
    dispatch(setForceSaveEmail(false));
  };
  return React.createElement("div", {
    className: "margin-top-4"
  }, React.createElement("div", {
    className: svs.core.detect.breakpoint.greaterThan('sm') ? 'scroll-margin-card' : 'scroll-margin-card-mobile',
    ref: emailRef
  }, React.createElement(PdCard, {
    isFocused: isFocused,
    onChange: onChange
  }, React.createElement(WhiteCardHeader, null, "E-post"), React.createElement(CardBody, {
    className: "f-left pd-card-body"
  }, React.createElement(EmailText, null)), React.createElement(CardExpandableBody, {
    className: "f-left pd-card-body"
  }, emailVerified || !emailExists || isForceSaveEmail ? React.createElement(EmailSave, null) : React.createElement(EmailConfirm, null), (!emailExists || emailVerified || isForceSaveEmail) && React.createElement(EmailFooter, null)))));
};
svs.myProfile.react.pages.myInformation.myInformation.email.EmailCard = EmailCard;

 })(window);